import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"

const Page2 = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/page1", { state: { inputValue } });
  };

  const secondpage = () => {
    navigate("/page5", { state: { allResults, binaryInputValue, inputValue , randomNum , roundCount} });
  };

    const min = 5;
    const max = 15;
    const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;

    console.log('randomNum: ',randomNum); 

  const location = useLocation();
  const binaryInputValue = location.state.binaryInputValue;
  const inputValue = location.state.inputValue;
  const roundCount = 0;

  let binaryInputValue56 = "";
  for (let i = 0; i < binaryInputValue.length; i++) {
    binaryInputValue56 += binaryInputValue[i].slice(0, 7) + ",";
  }
  binaryInputValue56 = binaryInputValue56.split(",");
  binaryInputValue56.pop();

  const splitInto28 = (array) => {
    let binaryString = arrayToString(array);

    const OrderForC = [
      57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43,
      35, 27, 19, 11, 3, 60, 52, 44, 36,
    ];

    const OrderForD = [
      63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45,
      37, 29, 21, 13, 5, 28, 20, 12, 4,
    ];

    let binary28bit_c = [];
    for (let i = 0; i < 28; i++) {
      binary28bit_c[i] = binaryString[OrderForC[i] - 1];
    }

    let binary28bit_d = [];
    for (let i = 0; i < 28; i++) {
      binary28bit_d[i] = binaryString[OrderForD[i] - 1];
    }

    return [binary28bit_c, binary28bit_d];
  };

  const arrayToString = (array) => {
    let string = "";
    for (let i = 0; i < array.length; i++) {
      string += array[i];
    }
    return string;
  };

  const stringToArray = (string) => {
    const chunks = [];
    for (let i = 0; i < 28; i += 7) {
      chunks.push(string.substring(i, i + 7));
    }
    return chunks;
  };

  const leftShift = (round, array) => {
    let c = array[0];
    let d = array[1];
    let shiftedCD = [];
    if (round === 1 || round === 2 || round === 9 || round === 16) {
      let shiftAmount = 1;
      let shiftedC =
        arrayToString(c).slice(shiftAmount) +
        arrayToString(c).slice(0, shiftAmount);
      let shiftedD =
        arrayToString(d).slice(shiftAmount) +
        arrayToString(d).slice(0, shiftAmount);
      shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
      return shiftedCD;
    } else {
      let shiftAmount = 2;
      let shiftedC =
        arrayToString(c).slice(shiftAmount) +
        arrayToString(c).slice(0, shiftAmount);
      let shiftedD =
        arrayToString(d).slice(shiftAmount) +
        arrayToString(d).slice(0, shiftAmount);
      shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
      return shiftedCD;
    }
  };

  const compPermute = (array) => {
    let compPermuteArray = [];
    let bigString = arrayToString(array[0].concat(array[1]));
    const compPermuteOrder = [
      14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7,
      27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39,
      56, 34, 53, 46, 42, 50, 36, 29, 32,
    ];
    for (let i = 0; i < 48; i++) {
      compPermuteArray[i] = bigString[compPermuteOrder[i] - 1];
    }
    return compPermuteArray;
  };

  const crctFormetForSplited = (array) => {
    const outputArray = [];
    for (const str of array) {
      for (const char of str) {
        outputArray.push(char);
      }
    }
    return outputArray;
  };

  const compute = (binaryInputValue, round) => {
    if (round === 1) {
      let splitedArray = splitInto28(binaryInputValue);

      let shiftedArray = leftShift(round, splitedArray);

      let compPermuteArray = compPermute(shiftedArray);

      return [splitedArray, shiftedArray, compPermuteArray];
    } else {
      let splitedArray = [
        crctFormetForSplited(binaryInputValue[0]),
        crctFormetForSplited(binaryInputValue[1]),
      ];

      let shiftedArray = leftShift(round, splitedArray);
      //console.log(shiftedArray);
      let compPermuteArray = compPermute(shiftedArray);
      //console.log(compPermuteArray);
      return [splitedArray, shiftedArray, compPermuteArray];
    }
  };

  const keyGeneration = () => {
    let allResults = [];
    let currInput = binaryInputValue;

    for (let round = 1; round < 17; round++) {
      let oneRoundResult = compute(currInput, round);
      //console.log(compute(currInput , round));
      currInput = oneRoundResult[1];
      allResults.push(oneRoundResult);
    }
    return allResults;
  };

  let allResults = keyGeneration();

  console.log(allResults);


  const svgVariant = {
    hidden: {
      opacity: 0
    },
    visible: {
      //y: 0,
      opacity: 1,
      transition: {
        delay: 1,
        //duration: 0.5
      }
    }
  }

  const horiSvgVariant = {
    hidden: {
      x: -1100
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 0.75
      }
    }
  }

  const vertiSvgVariant = {
    hidden: {
      y: -700
    },
    visible: {
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  }
  
  const variantsFor28Bits = {
    hidden: {
      opacity: 0
    },
    visible: {
      //y: 0,
      opacity: 1,
      transition: {
        delay: 1.25,
        //duration: 0.5
      }
    }
  }


  return (
    <>
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>In this page, the 56 bit conveted key is divided into 2 equal halves called Left Plain Text(LPT) and Right Plain Text(RPT)
        each containing 28 bits. LPT contains the first 28 bits and RPT contains the second 28 bits.      </p>
    </div>
     

      <div className="text-xl text-center py-5">Round 1 Key Generation</div>

      <div className="grid grid-cols-2 grid-rows-4 gap-4">
        <div className="col-span-2 row-span-2">
          <center>
            <p>56 Bit Binary Value</p>

            <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus max-w-fit">
            {allResults[0][0][0].slice(0, 7)}
                <br></br>
                {allResults[0][0][0].slice(7, 14)}
                <br></br>
                {allResults[0][0][0].slice(14, 21)}
                <br></br>
                {allResults[0][0][0].slice(21, 28)}
                <br></br>
                <hr className=" border border-stone-400 "></hr>
                {allResults[0][0][1].slice(0, 7)}
                <br></br>
                {allResults[0][0][1].slice(7, 14)}
                <br></br>
                {allResults[0][0][1].slice(14, 21)}
                <br></br>
                {allResults[0][0][1].slice(21, 28)}
                <br></br>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                width="700"
                height="99"
                viewBox="0 0 1032 99"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <motion.line
                  variants={vertiSvgVariant}
                  initial="hidden"
                  animate="visible"

                 x1="508.5" x2="508.5" y2="70" stroke="black" />
                <motion.line
                  variants={horiSvgVariant}
                  initial="hidden"
                  animate="visible"
                  x1="3" y1="69.5" x2="1029" y2="69.5" stroke="black" />
                <motion.path
                  variants={svgVariant}
                  initial="hidden"
                  animate="visible"
                  d="M3 99L5.88675 94L0.113249 94L3 99ZM3.5 94.5L3.5 70L2.5 70L2.5 94.5L3.5 94.5Z"
                  fill="black"
                />
                <motion.path
                  variants={svgVariant}
                  initial="hidden"
                  animate="visible"
                  d="M1028.5 99L1031.39 94L1025.61 94L1028.5 99ZM1029 94.5L1029 70L1028 70L1028 94.5L1029 94.5Z"
                  fill="black"
                />
              </svg>
            </div>
          </center>
        </div>
        <motion.div
          variants={variantsFor28Bits}
          initial="hidden"
          animate="visible"
        className="col-span-1">
          <center>
            <p>28 bit Left</p>
            <div
             className="fixed-height-div">
              <div className="max-w-fit bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {allResults[0][0][0].slice(0, 7)}
                <br></br>
                {allResults[0][0][0].slice(7, 14)}
                <br></br>
                {allResults[0][0][0].slice(14, 21)}
                <br></br>
                {allResults[0][0][0].slice(21, 28)}
                <br></br>
              </div>
            </div>
          </center>
        </motion.div>
        <motion.div 
        variants={variantsFor28Bits}
        initial="hidden"
        animate="visible"
        className="col-span-1">
          <center>
            <p>28 bit Right</p>
            <div className="fixed-height-div">
              <div className="max-w-fit bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {allResults[0][0][1].slice(0, 7)}
                <br></br>
                {allResults[0][0][1].slice(7, 14)}
                <br></br>
                {allResults[0][0][1].slice(14, 21)}
                <br></br>
                {allResults[0][0][1].slice(21, 28)}
                <br></br>
              </div>
            </div>
          </center>
        </motion.div>
      </div>

      <br></br>

      <div className="button-holder">
        <div className="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="circle-container">
          {[...Array(16)].map((_, index) => (
            <div
              key={index}
              className={`circle ${index === 0 ? "green" : "orange"}`}
            >
              {index + 1}
            </div>
          ))}
        </div>
        <div className="next-button" onClick={secondpage}>
          NEXT
        </div>
      </div>
    </>
  );
};

export default Page2;
